import { createContext, useContext, useState, useEffect } from "react";

type Flags = { [key: string]: boolean };

export const FeatureFlagsContext = createContext<Flags>({});

export const useFeatureFlags = () => useContext<Flags>(FeatureFlagsContext);

export const FeatureFlagsProvider = ({ children } : any) => {
  const [flags, setFlags] = useState<Flags | null>(null);

  useEffect(() => {
    const flagsJson = document.getElementById("nhd-flags")?.textContent ?? "{}";
    var newFlags = null;
    try {
      newFlags = JSON.parse(flagsJson);
    }
    catch { }

    setFlags(newFlags || {});
  }, []);

  if (flags === null)
    return null;

  return (
    <FeatureFlagsContext.Provider value={flags}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};
